import UIButton from 'UIComponents/button/UIButton';
import FormattedMessage from 'I18n/components/FormattedMessage';

// @ts-expect-error Untyped import
import PracticalExerciseWrapper from './PracticalExerciseWrapper';
// @ts-expect-error Untyped import
import PracticalExerciseInstructions from './PracticalExerciseInstructions';
// @ts-expect-error Untyped import
import PracticalExerciseStartButton from './PracticalExerciseStartButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const BASE_18N_KEY = 'learningCenter.practicalExercise';
const NotStartedPracticalExercise = ({
  advanceToNextContent,
  exercise,
  exerciseLocation,
  onStartClick
}) => {
  const renderButtons = () => {
    const graded = exercise.graded;
    const manuallyApproved = exercise.manuallyApproved;
    const trackerNotRequired = exercise.trackerNotRequired;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(UIButton, {
        className: "m-right-3",
        "data-test-id": "skip-nonstarted-practical-exercise",
        onClick: advanceToNextContent,
        use: "link",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${BASE_18N_KEY}.skip`
        })
      }), /*#__PURE__*/_jsx(PracticalExerciseStartButton, {
        exerciseLocation: exerciseLocation,
        graded: graded,
        isExternal: trackerNotRequired,
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `${BASE_18N_KEY}.startExercise`
        }),
        manuallyApproved: manuallyApproved,
        onStartClick: onStartClick,
        use: "primary"
      })]
    });
  };
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "not-started-practical-exercise",
    children: /*#__PURE__*/_jsx(PracticalExerciseWrapper, {
      buttons: renderButtons(),
      illustrationName: "building",
      statusSubtitleNode: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${BASE_18N_KEY}.statusSubtitle.notStarted`
      }),
      statusTitleI18n: `${BASE_18N_KEY}.statusTitle.notStarted`,
      children: /*#__PURE__*/_jsx(PracticalExerciseInstructions, {
        description: exercise.description,
        isGraded: exercise.graded,
        isManuallyApproved: exercise.manuallyApproved,
        name: exercise.name
      })
    })
  });
};
export default NotStartedPracticalExercise;